export default __webpack_public_path__ + "static/media/group_therapy3.56c2b424.png";